<template>
    <div class="vue-geo-locator">
        <button @click="geoLocate" :class="{'active': hasGeoLocation}" :title="translations.getCurrentLocationText">
            <span class="visually-hidden">
                {{ translations.getCurrentLocationText }}
            </span>
        </button>
    </div>
</template>

<script>
import translations from "../../mixins/translations";
import _ from "lodash";

export default {
    name: "GeoLocator",

    mixins: [translations],

    props: {
        usingInput: {
            type: Boolean,
            required: false,
            default: false,
        }
    },

    data() {
        return {
            geoLocation: {},
        }
    },

    computed: {
        hasGeoLocation() {
            return !lodash.isEmpty(this.geoLocation) && !this.usingInput;
        }
    },

    created() {
        this.$emit('loading', true);
        this.checkGeoPermissions();
    },

    methods: {
        checkGeoPermissions() {
            navigator.permissions.query({name: 'geolocation'})
                .then(response => {
                    if (!lodash.isEqual(response.state, 'granted')) {
                        this.$emit('loading', false);
                        return;
                    }

                    this.geoLocate();
                });
        },

        geoLocate() {
            this.$emit('loading', true);
            this.$emit('disabled', true);

            navigator.geolocation.getCurrentPosition(position => {
                    this.geoLocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };

                    const payload = this.geoLocation;
                    this.$emit('geo', {payload});
                },
                error => {
                    this.geoLocation = {};
                    this.$emit('geo-error');
                    this.$emit('geo', this.geoLocation);
                });
        },
    }
}
</script>